import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'

import Title from '../../components/Title'
// import Select from '../../components/Select'
import Button from '../../components/Button'
import { Link, useNavigate } from 'react-router-dom'
import ClassbookTable from '../../components/ClassbookTable'
import { useDispatch, useSelector } from 'react-redux'
import { getSchoolYears } from '../../actions/common'
import { getLesson, getStudyPeriod, getScClass, getClassbook, getGradeValue, getLessonChart, getClassTopic } from '../../actions/classbook'
import Loader from '../../components/Loader'
import { getCurrentPeriodUtils, getCurrentYearUtils } from '../../utils/classBook'
import TeacherInfo from './TeacherInfo/TeacherInfo'
import { Checkbox, Input } from '../../components/ModalInputs'
import ClassbookChart from './ClassbookChart/ClassbookChart'
import { getStudents } from '../../actions/students/list'
import moment from 'moment'
import { getDigitalExamBook } from '../../actions/directoryBasicEducation'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { useFormik } from 'formik'

const month = [
    { name: 'Январь', id: 1 },
    { name: 'Февраль', id: 2 },
    { name: 'Март', id: 3 },
    { name: 'Апрель', id: 4 },
    { name: 'Май', id: 5 },
    { name: 'Июнь', id: 6 },
    { name: 'Июль', id: 7 },
    { name: 'Август', id: 8 },
    { name: 'Сентябрь', id: 9 },
    { name: 'Октябрь', id: 10 },
    { name: 'Ноябрь', id: 11 },
    { name: 'Дкабрь', id: 12 },
]

const DigitalExamBook = () => {

    const goHome = useNavigate('/')
    const dispatch = useDispatch()

    const { schoolYears } = useSelector(state => state.common)
    const { list, loading: loadingSt } = useSelector(state => state.students)
    const { digitalExamBook } = useSelector(state => state.directoryBasicEducation)
    const { studyPeriod, lessons, scClass, } = useSelector(state => state.classbook)

    const [studPeriod, setStudPeriod] = useState(false) //месяц - уч период
    const [selectedValue, setSelectedValue] = useState(null);
    const [formData, setFormData] = useState({ scYear: "", studyPeriod: "", lesson: "", class: "", dropouts: 0 });
    // собрать Учпериод / месяц / ученик
    const [scYear, setScYear] = useState()
    const [period, setPeriod] = useState(null)
    const [stPeriod, setStPeriod] = useState([])
    const [stud, setStud] = useState({ name: "Выбрать", mid: 0 })

    const handleInputChange = (e) => {
        const { name, value, begdate, xp_key, term_end, term_begin, trmid, fio, mid } = e
        setSelectedValue()
        setFormData({
            ...formData,
            [name]: value
        })
        if (begdate) setScYear(xp_key)
        if (fio) setStud({ mid: mid })
        if (term_begin) setPeriod({ trimestr: trmid, begdate: term_begin, enddate: term_end, })
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        setFieldValue,
        resetForm,
    } = useFormik({
        initialValues: {},
        enableReinitialize: true,
        onSubmit: console.log
    })

    useEffect(() => {
        dispatch(getSchoolYears())
        dispatch(getGradeValue())
        dispatch(getStudents({ status: 'all' }))
    }, [])

    useEffect(() => {
        !!schoolYears?.length && !!values.scYear && dispatch(getStudyPeriod(values.scYear))
        // !!values.scYear && !!studyPeriod && setPeriod({ name: "Выбрать", trmid: 0 })
    }, [values.scYear])
    useEffect(() => {
        // !!schoolYears?.length && !!values.scYear && dispatch(getStudyPeriod(values.scYear))
        !!values.scYear && !!studyPeriod && setFieldValue('trimestr', { name: "Выбрать", trmid: 0 })
    }, [studyPeriod])

    useEffect(() => {
        schoolYears && setScYear(getCurrentYearUtils(schoolYears, moment()))
    }, [schoolYears])


    const handleSearch = () => {
        const forRequest = schoolYears.find(el => el.xp_key == values.scYear)
        dispatch(getDigitalExamBook({ ...values, begdate: forRequest?.begdate, enddate: forRequest?.enddate }));
    }

    const handleClassTopic = (year, sheid) => {
        dispatch(getClassTopic(year, sheid));
    }



    return (
        <>
            <Title title="Электронная зачетка" />
            <>
                <div className={styles.wrapperPanelClassbook}>
                    <div>
                        {schoolYears && studyPeriod && lessons && scClass &&
                            <>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>

                                        <Checkbox
                                            label='Уч. период'
                                            onChange={() => setStudPeriod(false)}
                                            checked={!studPeriod}
                                            name='kkalvisible'
                                            style={{ margin: '15px' }}
                                        />
                                        <Checkbox
                                            label='Месяц'
                                            checked={studPeriod}
                                            onChange={() => setStudPeriod(true)}
                                            name='kkalvisible'
                                            style={{ margin: '15px' }}
                                        />
                                    </div>
                                    {!studPeriod ?
                                        <>
                                            < CustomSelect
                                                title='Учебный период'
                                                valuesName="trimestr"
                                                options={!!studyPeriod.length ? arrayForSelect(studyPeriod, 'title', 'trmid') : []}
                                                value={values?.trimestr}
                                                setFieldValue={setFieldValue}
                                                disabled={!studyPeriod.length}
                                            />
                                            <CustomSelect
                                                title='Год'
                                                valuesName="scYear"
                                                value={values?.scYear}
                                                options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
                                                setFieldValue={setFieldValue}
                                            />

                                            <Checkbox
                                                label='За весь год'
                                                name='kkalvisible'
                                                style={{ margin: '15px' }}
                                            />

                                        </>
                                        :
                                        <>
                                            {/* <CustomSelect
                                                title='Год'
                                                valuesName="month"
                                                value={values.month}
                                                options={month && arrayForSelect(month, 'name', 'xp_key')}
                                                style={{ width: '120px' }}
                                                setFieldValue={setFieldValue}
                                            /> */}


                                            <input
                                                className={styles.inputSel}
                                                type='number'
                                                defaultValue={2024}
                                                style={{ width: '70px', marginTop: '9px' }}
                                            />
                                        </>
                                    }
                                </div>
                                {loadingSt ?
                                    <Loader /> :
                                    <CustomSelect
                                        title="Ученик"
                                        valuesName={"mid"}
                                        options={list && arrayForSelect(list?.studentList, 'fio', 'mid')}
                                        value={values.mid}
                                        setFieldValue={setFieldValue}
                                        width={300}
                                    />
                                }
                            </>
                        }
                        <br />
                        {!!digitalExamBook && !digitalExamBook?.nnz_fill_journalstudent.length && <h3>Данные отсутствуют</h3>}
                    </div>
                    <Button onClick={handleSearch} disabled={!values.mid}>Обновить</Button>
                </div>

                < footer className={styles.footer} >
                    <>
                        <div className={styles.export}>
                            <i>
                                <svg
                                    width="18"
                                    height="19"
                                    viewBox="0 0 18 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_477_4122)">
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M3.58858 1.26446C3.43857 1.34117 3.34484 1.46633 3.30332 1.64524C3.28574 1.7211 3.27098 2.51388 3.27052 3.40695L3.26968 5.03075L2.11743 5.04172L0.965219 5.05269L0.733258 5.16694C0.45823 5.3024 0.24216 5.52315 0.111238 5.80239L0.0177227 6.0019V9.76362C0.0177227 12.6963 0.0275312 13.5576 0.0621953 13.6717C0.161652 13.9989 0.502492 14.3518 0.843895 14.4809C0.977805 14.5316 1.17598 14.5428 2.13406 14.5542L3.26602 14.5676L3.27664 15.9801C3.28669 17.3188 3.29091 17.3988 3.35757 17.5119C3.39624 17.5776 3.47253 17.6646 3.52712 17.7052L3.62641 17.7792H9.00014H14.3739L14.4732 17.7052C14.5278 17.6646 14.6041 17.5776 14.6427 17.5119C14.7094 17.3988 14.7136 17.3188 14.7237 15.9775L14.7343 14.5625H15.7472C16.3043 14.5625 16.8447 14.5464 16.9482 14.5268C17.4486 14.4319 17.8801 14.0248 17.9511 13.5805C17.9638 13.501 17.988 13.4274 18.0047 13.417C18.0217 13.4065 18.0353 11.7729 18.0353 9.7419C18.0353 7.31334 18.0235 6.09292 18.0001 6.10737C17.9804 6.11954 17.965 6.09204 17.965 6.04476C17.965 5.90259 17.761 5.54266 17.5923 5.38713C17.5043 5.30606 17.3426 5.19767 17.2329 5.1462L17.0333 5.05269L15.8835 5.04172L14.7337 5.03078L14.7234 3.31906C14.7135 1.68067 14.71 1.60228 14.6427 1.48802C14.6041 1.42235 14.5278 1.33533 14.4732 1.29466L14.3739 1.22065L9.04152 1.21172C4.01784 1.20332 3.70213 1.20638 3.58858 1.26446ZM4.35952 3.66401V5.03511H9.00014H13.6408V3.66401V2.29292H9.00014H4.35952V3.66401ZM0.0170898 9.7812C0.0170898 11.8018 0.0213086 12.6284 0.0265117 11.6181C0.0316797 10.6078 0.0316797 8.95457 0.0265117 7.94429C0.0213086 6.93397 0.0170898 7.7606 0.0170898 9.7812ZM1.14817 6.18925C1.09484 6.24817 1.08999 6.54964 1.08999 9.8049C1.08999 13.2007 1.0928 13.3588 1.15429 13.4144C1.211 13.4658 1.33904 13.4726 2.24227 13.4726H3.26598L3.27664 12.0576C3.2868 10.7037 3.29038 10.6372 3.35946 10.5196C3.39919 10.452 3.48459 10.361 3.54924 10.3174L3.6668 10.2382H9.00014H14.3335L14.4511 10.3174C14.5157 10.361 14.6011 10.452 14.6408 10.5196C14.7099 10.6372 14.7135 10.7037 14.7237 12.0576L14.7343 13.4726H15.7641C16.7172 13.4726 16.7983 13.4678 16.8521 13.4083C16.9054 13.3494 16.9103 13.0479 16.9103 9.79266C16.9103 6.39681 16.9075 6.23879 16.846 6.18313C16.7866 6.12935 16.1912 6.12495 8.99403 6.12495C1.49411 6.12495 1.20421 6.12734 1.14817 6.18925ZM14.0099 7.42271C13.6201 7.52037 13.3538 7.89285 13.4043 8.26962C13.4312 8.47005 13.5853 8.71238 13.757 8.82397C13.885 8.90722 13.9399 8.91987 14.1739 8.91987C14.4161 8.91987 14.4587 8.90922 14.5958 8.81419C14.774 8.69062 14.9417 8.39344 14.9413 8.20167C14.9409 7.90045 14.7614 7.6025 14.5101 7.48571C14.3625 7.41715 14.1426 7.38945 14.0099 7.42271ZM4.35952 14.0175V16.707H9.00014H13.6408V14.0175V11.3281H9.00014H4.35952V14.0175ZM6.30893 12.4319C6.1636 12.4956 6.0197 12.6744 5.99112 12.8266C5.94057 13.0962 6.14669 13.4078 6.40663 13.4547C6.46988 13.4662 7.67932 13.4709 9.09426 13.4653C11.6297 13.4552 11.6683 13.454 11.764 13.3825C11.9435 13.2485 12.006 13.131 12.006 12.9277C12.006 12.7243 11.9435 12.6069 11.764 12.4728C11.6682 12.4013 11.6322 12.4002 9.04152 12.3926C6.9126 12.3863 6.39587 12.3937 6.30893 12.4319ZM6.25827 14.6277C6.12363 14.6999 5.97671 14.94 5.97671 15.0879C5.97671 15.2383 6.12292 15.4855 6.25796 15.5636C6.37847 15.6332 6.43511 15.6347 9.00014 15.6347C11.5652 15.6347 11.6218 15.6332 11.7423 15.5636C11.8774 15.4855 12.0236 15.2383 12.0236 15.0879C12.0236 14.94 11.8767 14.6999 11.742 14.6277C11.6267 14.5658 11.4851 14.5625 9.00014 14.5625C6.51516 14.5625 6.37362 14.5658 6.25827 14.6277Z"
                                            fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_477_4122">
                                            <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </i>
                            <span>Печать</span>
                        </div>
                        <Link className={styles.close} to='/'><Button mode='white'>Закрыть</Button></Link>
                    </>
                </footer>
            </>
        </>
    )
}

export default DigitalExamBook
